import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import _ from 'underscore';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        base_url: {
        },
    },
    getters: {
        baseUrl(state) {
            return state.base_url;
        },
    },
    mutations: {
        SET_BASE_URL: (state, base_url) => {
            _.each(base_url, (v,k) => {
                state.base_url[k] = v
            })
        }
    },
    actions: {
        init({ commit }) {   
            return new Promise((resolve, reject) => {
                axios.get(window._globalConfig.configUrl).then(response => {
                    commit('SET_BASE_URL', response.data.data);
                    resolve();
                }).catch(error => {
                    reject(error)
                })
            });            
        }
    },
})